import { observer } from 'mobx-react';
import React from 'react';
import { Card, CardContent, ITagProps, Separator } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Package } from '../MobileBusinessInterfaces';
import PackageCardContent from './PackageCardContent';
import PackageCardHeaderContent from './PackageCardHeaderContent';

interface MobileBusinessPackageCardProps {
  index: number;
  mobilePackage: Package;
}

@observer
class PackageCard extends React.Component<MobileBusinessPackageCardProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  private tagTop(mobilePackage: Package): ITagProps | boolean {
    const translate = this.context.translate;
    if (mobilePackage.isOffer) {
      return {
        text: translate('mobileBusiness.offerBadgeText'),
        purpose: 'campaign-3',
        size: 'tiny'
      };
    }
    if (mobilePackage.isUnlimitedPlus) {
      return {
        text: translate('mobileBusiness.premiumBadgeText'),
        purpose: 'recommended',
        size: 'tiny'
      };
    }
    return true;
  }

  public render() {
    const { index, mobilePackage } = this.props;
    const { isUnlimitedPlus } = mobilePackage;

    return (
      <Card className="text-left" type={isUnlimitedPlus ? 'light' : undefined} background={isUnlimitedPlus ? 'transparent' : 'brand-secondary-bg-subtlest'}>
        <CardContent tagTop={this.tagTop(mobilePackage)}>
          <PackageCardHeaderContent {...{ index, mobilePackage }} />
          <Separator spacing="small" color="invisible" />
          <PackageCardContent {...{ mobilePackage }} />
        </CardContent>
      </Card>
    );
  }
}

export default PackageCard;
